export default __webpack_public_path__ + "static/media/newfilegroupbutton@2x.6f0078be.png";